module.exports = __webpack_public_path__ + "media/down.ffc811c1.ogg";